
/**Indica de que área proviene un movimiento de caja */
export enum RubroMovimientoCaja {
    Documentacion,
    EntregaDomicilio,
    EntregaOcurre,
    Cobranza,
    Facturacion,
    PaquetePP,
    EntregaZE
}

/**Tipo de movimiento de caja */
export enum TipoMovimientoCaja {
    /**Aumenta el monto de la caja */
    FletePagado,
}

/**Forma de pago del movimiento de caja. */
export enum FormaPagoMovimientoCaja {
    Efectivo = 0,
        Cheque = 1,
        Transferencia = 2,
        TarjetaCredito = 3,
        TarjetaDebito = 4,
        //NotaCredito = 5,
        //NotaCargo = 6,

        ValesDespensa = 7,
        DacionPago = 8,
        PagoSubrogacion = 9,
        PagoConsignacion = 10,
        Condonacion = 11,
        Compensacion = 12,
        Novacion = 13,
        Confusion = 14,
        RemisionDeuda = 15,
        PrescripcionCaducidad = 16,
        SatisfaccionAcreedor = 17,        
        TarjetaServicios = 19,
        MonederoElectronico = 20,
        DineroElectronico = 21
    
}

/**Un movimiento de cargo o abono a una caja */
export interface MovimientoCaja {
    IdRegistro: number;
    Nombre: string;

    /**Fecha del movimiento de caja */
    Fecha: Date;

    /**Importe del movimiento */
    Importe: number;

    /**Rubro del movimiento */
    Rubro: RubroMovimientoCaja;

    /**Forma de pago del movimiento */
    FormaPago: FormaPagoMovimientoCaja;

    /**Id de la caja en donde aplicó ete movimiento */
    IdCaja: number;

    /**Id del usuario que fue responsable de este movimiento */
    IdUsuario: number;
}


// WEBPACK FOOTER //
// ./app/models/movimientocaja.ts